import { useState } from "react";
import { CheckIcon, LockClosedIcon } from "@heroicons/react/20/solid";
import sendFormData from "../utils/sendFormData";
import { useAuth } from "../utils/useAuth";

export default function LoginScreen() {
  const [loginfailed, setLoginfailed] = useState(false);
  const { login } = useAuth();
  async function handleSubmit(event) {
    event.preventDefault();
    let resp = await sendFormData(event, event.target);
    if (resp.ok) {
      setLoginfailed(false);
      const response = await fetch("/api/users/me/", {
        credentials: "same-origin",
      });
      if (response.ok) {
        const data = await response.json();
        await login(data);
      } else {
        alert(response.statusText || "Fehler beim Login");
      }
    } else {
      setLoginfailed(true);
    }
  }
  return (
    <>
      <div
        className="relative z-10"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div
              className="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6"
              id="login-modal-panel"
            >
              <div>
                <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
                  <CheckIcon />
                </div>
                <form
                  className="mt-8 space-y-6"
                  action="/api/token"
                  method="POST"
                  onSubmit={handleSubmit}
                >
                  <div className="-space-y-px rounded-md shadow-sm">
                    <div>
                      <label htmlFor="login-user-input" className="sr-only">
                        E-Mail
                      </label>
                      <input
                        id="login-user-input"
                        name="username"
                        type="text"
                        autoComplete="email"
                        required
                        className="relative block w-full appearance-none rounded-none rounded-t-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-stone-500 focus:outline-none focus:ring-stone-500 sm:text-sm"
                        placeholder="E-Mail"
                      />
                    </div>
                    <div>
                      <label htmlFor="password" className="sr-only">
                        Passwort
                      </label>
                      <input
                        id="password"
                        name="password"
                        type="password"
                        autoComplete="current-password"
                        required
                        className="relative block w-full appearance-none rounded-none rounded-b-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-stone-500 focus:outline-none focus:ring-stone-500 sm:text-sm"
                        placeholder="Passwort"
                      />
                    </div>
                  </div>
                  {loginfailed && (
                    <p x-show="failedlogin" className="text-red-500">
                      Falsche Zugangsdaten
                    </p>
                  )}

                  <div>
                    <button
                      type="submit"
                      className="group relative flex w-full justify-center rounded-md border border-transparent bg-stone-600 py-2 px-4 text-sm font-medium text-white hover:bg-stone-700 focus:outline-none focus:ring-2 focus:ring-stone-500 focus:ring-offset-2"
                    >
                      <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                        <LockClosedIcon />
                      </span>
                      Anmelden
                    </button>
                  </div>
                  <a
                    className="block mt-5 text-center text-sm/6 font-medium text-indigo-600 hover:text-indigo-500"
                    href="/password-reset"
                  >
                    Passwort vergessen?
                  </a>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
